import React from 'react'
import Presenter from "./SearchPresenter"
import { useQuery, useLazyQuery } from '@apollo/react-hooks';
import { SEE_RECENTUSER } from '../../Queries/User/seeRecentUser';
import { useState } from 'react';
import useInput from '../../Hooks/useInput';
import { SEARCH_USER } from '../../Queries/User/searchUser';
import { useHistory } from 'react-router-dom'


export default()=>{
    const search = useInput("")
    const {data, loading} = useQuery(SEE_RECENTUSER)
    const [searchUserQuery, { called, data:searchUser,loading:searchUserLoading}] = useLazyQuery(SEARCH_USER,{
        variables:{
            name:search.value
        }
    })
    const [recentSee, setRecentSee] = useState(true)
    const history = useHistory();
    const onSubmit = async(e) =>{
        e.preventDefault();
        await searchUserQuery();
    }

    return(
        <Presenter 
            data={data}
            loading={loading}
            recentSee={recentSee}
            setRecentSee={setRecentSee}
            search={search}
            onSubmit={onSubmit}
            searchUser={searchUser}
            searchUserLoading={searchUserLoading}
            called={called}
            history={history}
        />
    )
}